import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Formik, Form, Field } from 'formik';
import {
  // Flex,
  Text,
  FormControl,
  FormLabel,
  NumberInput,
  NumberInputField,
  // Select,
  Switch,
  Button,
  HStack,
} from '@chakra-ui/react';
import api from "api/axiosConfig";
import API_BASE from "configs/hostConfig";

const PreferenceForm = ({ preferences }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  function updatePreferences(values) {
    // console.log('Form submitted 2222:', values);
    setIsSubmitting(true);
    api
      .post(`${API_BASE}/api/user/preferences`, values)
      // .then((res) => {
      //   if (res.status == 200) {
      //     navigate('/student-profile/dashboard');
      //   }
      // })
      .catch(() => console.log('Failed to update preferences!'))
      .finally(() => setIsSubmitting(false));
  }

  return (
    <Formik
      initialValues={preferences}
      enableReinitialize
      onSubmit={(values) => {
        // console.log('Form values:', values);
        updatePreferences(values);
      }}
    >
      {({ handleSubmit, values }) => (
        <Form onSubmit={handleSubmit}>
          <Text fontSize="md" fontWeight="bold">
            Learning
          </Text>

          <FormControl mb={4}>
            <HStack justify="space-between">
              <FormLabel mb="0">Assignment Completion Time (Days)</FormLabel>

              <Field name="assignmentDueDays">
                {({ form }) => (
                  <NumberInput
                    min={1}
                    value={values.assignmentDueDays}
                    onChange={(value) =>
                      form.setFieldValue('assignmentDueDays', value)
                    }
                  >
                    <NumberInputField />
                  </NumberInput>
                )}
              </Field>
            </HStack>
          </FormControl>
          <FormControl mb={4}>
            <HStack justify="space-between">
              <FormLabel mb="0">Target Essays per Month</FormLabel>

              <Field name="essayGoalPerMonth">
                {({ form }) => (
                  <NumberInput
                    min={1}
                    value={values.essayGoalPerMonth}
                    onChange={(value) =>
                      form.setFieldValue('essayGoalPerMonth', value)
                    }
                  >
                    <NumberInputField />
                  </NumberInput>
                )}
              </Field>
            </HStack>
          </FormControl>

          <FormControl mb={4}>
            <HStack justify="space-between">
              <FormLabel mb="0">
                Impromptu Story Completion Time (Days)
              </FormLabel>

              <Field name="storyDueDays">
                {({ form }) => (
                  <NumberInput
                    min={1}
                    value={values.storyDueDays}
                    onChange={(value) =>
                      form.setFieldValue('storyDueDays', value)
                    }
                  >
                    <NumberInputField />
                  </NumberInput>
                )}
              </Field>
            </HStack>
          </FormControl>

          <FormControl mb={4}>
            <HStack justify="space-between">
              <FormLabel mb="0">Target Impromptu Stories per Month</FormLabel>

              <Field name="storyGoalPerMonth">
                {({ form }) => (
                  <NumberInput
                    min={1}
                    value={values.storyGoalPerMonth}
                    onChange={(value) =>
                      form.setFieldValue('storyGoalPerMonth', value)
                    }
                  >
                    <NumberInputField />
                  </NumberInput>
                )}
              </Field>
            </HStack>
          </FormControl>
          {/* 
          <FormControl mb={4}>
            <HStack>
              <Flex flex="1">
                <FormLabel mb="0">Report Generation Frequency</FormLabel>
              </Flex>
              <Flex flex="0.8">
                <Field name="reportFrequency" as="select">
                  {({ field }) => (
                    <Select placeholder="Select frequency" {...field}>
                      <option value="1">Weekly</option>
                      <option value="2">Biweekly</option>
                      <option value="3">Monthly</option>
                      <option value="4">Annually</option>
                    </Select>
                  )}
                </Field>
              </Flex>
            </HStack>
          </FormControl> */}
          <Text fontSize="md" fontWeight="bold" mt={6}>
            Email Notifications
          </Text>
          <Text fontSize="sm" color="gray.500" mt={2} mb={4}>
            Stay updated with occasional emails we think you&apos;ll enjoy. Use
            this section to manage your email preferences.
          </Text>
          <FormControl
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={4}
          >
            <FormLabel mb="0">New Assignment Notifications</FormLabel>
            <Field name="notifyAssignment" type="checkbox">
              {({ form }) => (
                <Switch
                  isChecked={values.notifyAssignment}
                  onChange={(e) =>
                    form.setFieldValue('notifyAssignment', e.target.checked)
                  }
                  colorScheme="green"
                />
              )}
            </Field>
          </FormControl>

          <FormControl
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={4}
          >
            <FormLabel mb="0">Receive learning reports</FormLabel>
            <Field name="sendReport" type="checkbox">
              {({ form }) => (
                <Switch
                  isChecked={values.sendReport}
                  onChange={(e) =>
                    form.setFieldValue('sendReport', e.target.checked)
                  }
                  colorScheme="green"
                />
              )}
            </Field>
          </FormControl>

          <FormControl
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={4}
          >
            <FormLabel mb="0">
              Subscribe to subscribeBlogs about writing skills
            </FormLabel>
            <Field name="subscribeBlogs" type="checkbox">
              {({ form }) => (
                <Switch
                  isChecked={values.subscribeBlogs}
                  onChange={(e) =>
                    form.setFieldValue('subscribeBlogs', e.target.checked)
                  }
                  colorScheme="green"
                />
              )}
            </Field>
          </FormControl>

          <FormControl
            display="flex"
            alignItems="center"
            justifyContent="space-between"
            mb={4}
          >
            <FormLabel mb="0">Subscribe to news from Dynivy Academy</FormLabel>
            <Field name="subscribeNews" type="checkbox">
              {({ form }) => (
                <Switch
                  isChecked={values.subscribeNews}
                  onChange={(e) =>
                    form.setFieldValue('subscribeNews', e.target.checked)
                  }
                  colorScheme="green"
                />
              )}
            </Field>
          </FormControl>

          <Button type="submit" colorScheme="green" disabled={isSubmitting}>
            Update Preferences
          </Button>
        </Form>
      )}
    </Formik>
  );
};

PreferenceForm.propTypes = {
  preferences: PropTypes.objectOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.bool, PropTypes.number])
  ),
};

export default PreferenceForm;
